import React from "react";
import styles from "./index.module.scss";
import HotEvents from "./HotEvents";
import PageFooter from "../Home/PageFooter";
import NavBar from "@src/components/NavBar";

export default () => {
  const onLogoClick = () => {
    window.location.href = "/";
  };
  return (
    <div className={styles.root}>
      <NavBar active={true} onLogoClick={onLogoClick} />
      <HotEvents />
      <PageFooter />
    </div>
  );
};
